import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const performanceRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-performance',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance',
};
